import Vue from "vue";
import moment from "moment";
/**
 * Converts a epoch timestamp to date format.
 * Example: 1591747200000 => 10 Jun 2020 00:00:00
 *
 * @param  {String} str the string to convert
 * @return {String}
 */

Vue.filter("date", str => {
  return str && str !== "-" ? moment(new Date(str)).format("DD MMMM YYYY") : "";
});

Vue.filter("dateTime", str => {
  return str && str !== "-"
    ? moment(new Date(str)).format("DD MMM YYYY HH:mm:ss")
    : "-";
});

Vue.filter("dateHourTime", str => {
  return str && str !== "-"
    ? moment(new Date(str)).format("DD MMM YYYY HH:mm")
    : "";
});

Vue.filter("dateHour", str => {
  return str && str !== "-"
    ? moment(new Date(str)).format("DD-MM-YYYY HH:mm")
    : str;
});

Vue.filter("dateLLLL", str => {
  return str && str !== "-" ? moment(new Date(str)).format("LLLL") : "-";
});

Vue.filter("dateInput", str => {
  return str && str !== "-" ? new Date(str).toISOString().substring(0, 10) : "";
});
